<mat-toolbar color="primary" class="footer">
  Contact the IBEW Government Affairs Department at  
  <a href="mailto:GovernmentAffairs@ibew.org">
     GovernmentAffairs&#64;ibew.org 
  </a>   
  for further information about these and other votes. Powered by the 
  <a href="https://developers.google.com/civic-information">Google Civic Information API</a>
</mat-toolbar>